<cache-date></cache-date>

<period></period>


<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<hr/>

<chart [data]="chartData.data" [options]="chartData.options" (onFilterChange)="updateData($event)" [sextant]="'chart'" [url]="filter.currentUrl"></chart>

<hr>

<ngb-pagination
	[extlinks]="links"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	*ngIf="!paginationLoader && pagination.pageCount > 1"
></ngb-pagination>

<ref_status [stats]="stats"></ref_status>

<loading [isLoad]="statsLoader"></loading>
<table class="table table-bordered table-nonfluid" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
	<tr>
		<th>
			{{ 'adminstat.common.Date' | translate }}
		</th>

		<th>
			{{ 'adminstat.common.Total info' | translate }}
		</th>
	</tr>
	</thead>

	<tbody>
	<tr *ngFor="let stat of stats">
		<td [class]="stat.day == 0 || stat.day == 6 ? 'table-info' : ''">
			{{ stat.currentPeriod }}
		</td>

		<td class="js-ul-billing-info">
			<table class="table">
				<tr *ngFor="let key of ['searchedCount', 'searchedUniqCount', 'selectedCount', 'saveContactCount', 'attachCount']">
					<td>
						{{ 'adminstat.billing.domain_billing.' + key | translate }}
					</td>

					<td>
						<button-anhor *ngIf="stat[key] > 0; else domainActionsOther2" (click)="showDetails(key, stat)" [sextant]="'domain-actions-detail'" class="js-ul-domain-actions-details" [attr.data-key]="key">
							{{ stat[key] }}
						</button-anhor>

						<ng-template #domainActionsOther2>
							0
						</ng-template>
					</td>
				</tr>
			</table>
		</td>
	</tr>
	</tbody>
</table>
